import { render } from "./UserSettingsModal.vue?vue&type=template&id=b1326abe&ts=true"
import script from "./UserSettingsModal.vue?vue&type=script&lang=ts"
export * from "./UserSettingsModal.vue?vue&type=script&lang=ts"

import exportComponent from "/srv/stamincasa/stamincasa-matematica/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__